import React, {ReactNode} from 'react';

import {OverlayPlacementType} from 'app/general/overlays';

// tooltip controlling props shared across avatar components
export interface AvatarTooltipsProps {
  // tooltip position
  tooltipPlacement?: OverlayPlacementType;
  // this controls the tooltip
  // - if null, no tooltip will be shown
  // - if ReactNode, will be shown before the tooltip content
  // - if function, it will replace the tooltip content, receiving the item name as argument
  tooltipTitle?: null | ReactNode | ((title: string) => ReactNode);
}

export function getTooltipContent(
  content: string | ReactNode,
  title?: ReactNode | ((title: string | ReactNode) => ReactNode)
): ReactNode {
  if (title === null || content === '') {
    return null;
  }

  return typeof title === 'function' ? (
    title(content)
  ) : (
    <>
      {title != null ? <div>{title}</div> : null}
      {content}
    </>
  );
}
